import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import styles from './FlexboxPane.module.scss.js';
import Flexbox from '../Flexbox/index.js';

var _excluded = ["children", "className", "flexboxChild", "noTopPadding", "noRightPadding", "noBottomPadding", "noLeftPadding"];
var FlexboxPaneChild = function FlexboxPaneChild(_ref) {
  var children = _ref.children,
    className = _ref.className,
    flexboxChild = _ref.flexboxChild,
    noTopPadding = _ref.noTopPadding,
    noRightPadding = _ref.noRightPadding,
    noBottomPadding = _ref.noBottomPadding,
    noLeftPadding = _ref.noLeftPadding,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Flexbox.Child, _extends({
    className: cx(styles.flexboxPaneChild, noTopPadding && 'pt-0', noRightPadding && 'pr-0', noBottomPadding && 'pb-0', noLeftPadding && 'pl-0', className)
  }, flexboxChild, props), children);
};
FlexboxPaneChild.propTypes = {
  children: PropTypes.node,
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  flexboxChild: PropTypes.object,
  noTopPadding: PropTypes.bool,
  noRightPadding: PropTypes.bool,
  noBottomPadding: PropTypes.bool,
  noLeftPadding: PropTypes.bool
};
FlexboxPaneChild.defaultProps = {
  flexboxChild: {
    flexFill: true
  },
  noTopPadding: false,
  noRightPadding: false,
  noBottomPadding: false,
  noLeftPadding: false
};

export { FlexboxPaneChild as default };
//# sourceMappingURL=FlexboxPaneChild.js.map
